/**
 * Product Series (leaves-56f1) as the trionn.com “Selected work” split.
 * Desktop scroll pins the screen and slides series cards across, matching
 * the reference timing: letters unblur, cards rise, the divider grows.
 */
(function () {
  'use strict';

  if (!document.body || document.documentElement.dataset.leavesSeriesTrionn === '1') return;
  document.documentElement.dataset.leavesSeriesTrionn = '1';

  var SECTION_ID = 'leaves-56f1';
  var EASE = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
  var SINE = 'cubic-bezier(0.39, 0.575, 0.565, 1)';
  var BLURBS = {
    'lnt track light series': 'Bendable track lights for custom outdoor layouts.',
    'ground spike light series': 'Ground spike lights for lawns and garden edges.',
    'hanging series': 'Hanging lights for ceilings, umbrellas, and covered patios.',
  };

  function textOf(node) {
    return String((node && node.textContent) || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function hideOriginal(node) {
    if (!node) return;
    node.classList.add('leaves-original-replaced');
    node.setAttribute('hidden', '');
  }

  function findSection() {
    return document.querySelector('#leaves-home [data-section-id="' + SECTION_ID + '"]');
  }

  function desktopMotion() {
    return (
      window.matchMedia('(min-width: 900px)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function collect(section) {
    var flex = section.querySelector('.leaves-flex-section') || section;
    var title = 'Give a new look';
    var headings = flex.querySelectorAll(':scope > h3, :scope > [data-leaves-type="Heading2"]');
    Array.prototype.forEach.call(headings, function (heading) {
      var value = textOf(heading);
      if (/give a new look/i.test(value)) title = value;
    });

    var more = flex.querySelector(':scope > a[data-leaves-type="Button2"], :scope > a');
    var moreHref = (more && more.getAttribute('href')) || '/pages/3purchase-process';

    var items = [];
    var cards = flex.querySelectorAll('[data-leaves-type="ContentListItem"]');
    Array.prototype.forEach.call(cards, function (card) {
      var image = card.querySelector('img');
      var name = textOf(card.querySelector('h3'));
      var src = image && (image.getAttribute('src') || image.currentSrc);
      if (!src || !name) return;
      items.push({
        name: name,
        href: card.getAttribute('data-href') || moreHref,
        image: src,
        blurb: BLURBS[name.toLowerCase()] || 'A Leaves outdoor lighting series.',
      });
    });

    return { flex: flex, headings: headings, more: more, title: title, moreHref: moreHref, items: items };
  }

  function splitTitle(title) {
    var words = title.split(' ');
    if (words.length < 3) return escapeHtml(title);
    var breakAt = Math.ceil(words.length / 2);
    return escapeHtml(words.slice(0, breakAt).join(' ')) + '<br>' + escapeHtml(words.slice(breakAt).join(' '));
  }

  function renderCard(item) {
    return (
      '<article class="leaves-series-trionn__card">' +
      '<div class="leaves-series-trionn__rule" aria-hidden="true"></div>' +
      '<div class="leaves-series-trionn__inner">' +
      '<div class="leaves-series-trionn__body">' +
      '<a class="leaves-series-trionn__frame" href="' +
      escapeAttr(item.href) +
      '" aria-label="' +
      escapeAttr(item.name) +
      '">' +
      '<img alt="" src="' +
      escapeAttr(item.image) +
      '"></a>' +
      '<div class="leaves-series-trionn__meta">' +
      '<h3 class="leaves-series-trionn__name">' +
      escapeHtml(item.name) +
      '</h3>' +
      '<p class="leaves-series-trionn__blurb">' +
      escapeHtml(item.blurb) +
      '</p></div></div></div></article>'
    );
  }

  function splitChars(title) {
    var html = title.innerHTML.split(/<br\s*\/?>/i).map(function (line) {
      var chars = line.replace(/&amp;|&lt;|&gt;|&#39;|&quot;|[^&]/g, function (token) {
        if (token.charAt(0) === '&') return '<span class="lst-char">' + token + '</span>';
        if (token === ' ') return '<span class="lst-char">&nbsp;</span>';
        return '<span class="lst-char">' + escapeHtml(token) + '</span>';
      });
      return '<span class="lst-line">' + chars + '</span>';
    });
    title.innerHTML = html.join('');
  }

  function playTitle(title) {
    if (title.dataset.played === '1') return;
    title.dataset.played = '1';
    if (!desktopMotion()) {
      title.querySelectorAll('.lst-char').forEach(function (ch) {
        ch.style.opacity = '1';
        ch.style.filter = 'none';
      });
      return;
    }
    title.animate([{ opacity: 0, filter: 'blur(12px)' }, { opacity: 1, filter: 'blur(0px)' }], {
      duration: 500,
      easing: EASE,
      fill: 'forwards',
    });
    var chars = Array.prototype.slice.call(title.querySelectorAll('.lst-char'));
    var order = chars.map(function (_, index) {
      return index;
    });
    for (var i = order.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = order[i];
      order[i] = order[j];
      order[j] = swap;
    }
    chars.forEach(function (ch, index) {
      ch.animate([{ opacity: 0, filter: 'blur(12px)' }, { opacity: 1, filter: 'blur(0px)' }], {
        duration: 800,
        delay: order[index] * 50,
        easing: EASE,
        fill: 'forwards',
      });
    });
  }

  function playMeta(card) {
    if (card.dataset.played === '1') return;
    card.dataset.played = '1';
    var name = card.querySelector('.leaves-series-trionn__name');
    var blurb = card.querySelector('.leaves-series-trionn__blurb');
    if (name) {
      name.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 700, easing: SINE, fill: 'forwards' });
    }
    if (blurb) {
      blurb.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 600, easing: SINE, fill: 'forwards' });
    }
  }

  function growLine(card, index) {
    if (card.dataset.lined === '1') return;
    card.dataset.lined = '1';
    var line = card.querySelector('.leaves-series-trionn__rule');
    if (!line) return;
    line.animate([{ transform: 'scaleY(0)' }, { transform: 'scaleY(1)' }], {
      duration: 1200,
      delay: index * 100,
      easing: EASE,
      fill: 'forwards',
    });
  }

  function cardY(ratio) {
    if (ratio > 1.2) return 550;
    if (ratio > 0.75) {
      var progress = (1.2 - ratio) / 0.45;
      var eased = 1 - Math.pow(1 - progress, 3);
      return 550 * (1 - eased);
    }
    return 0;
  }

  function bindMotion(pin, sticky, track, title) {
    var cards = Array.prototype.slice.call(track.querySelectorAll('.leaves-series-trionn__card'));
    var inners = cards.map(function (card) {
      return card.querySelector('.leaves-series-trionn__inner');
    });
    var metrics = null;
    var mode = '';
    var current = 0;
    var target = 0;
    var running = false;
    var lastTime = 0;
    var snapped = false;

    function revealTitle() {
      if (title.dataset.played === '1') return;
      var top = metrics ? metrics.start - window.scrollY : title.getBoundingClientRect().top;
      if (top < window.innerHeight * 0.9) playTitle(title);
    }

    function measure() {
      var view = window.innerHeight;
      var distance = view * 2;
      var hold = Math.round(view * 0.85);
      pin.style.height = view + distance + hold + 'px';
      metrics = {
        view: view,
        distance: distance,
        hold: hold,
        start: pin.getBoundingClientRect().top + window.scrollY,
        travel: Math.max(0, track.scrollWidth - window.innerWidth),
        width: window.innerWidth,
      };
    }

    function readTarget() {
      if (!metrics) measure();
      if (mode !== 'fixed') metrics.start = pin.getBoundingClientRect().top + window.scrollY;
      var raw = (window.scrollY - metrics.start) / metrics.distance;
      if (raw < 0) return 0;
      if (raw > 1) return 1;
      return raw;
    }

    function place() {
      var view = metrics.view;
      var top = metrics.start - window.scrollY;
      var bottom = top + view + metrics.distance + metrics.hold;
      var next = top > 0 ? 'before' : bottom > view ? 'fixed' : 'after';
      if (next === mode) return;
      mode = next;
      sticky.style.width = '100%';
      sticky.style.height = view + 'px';
      sticky.style.left = next === 'before' ? 'auto' : '0px';
      if (next === 'before') {
        sticky.style.position = 'relative';
        sticky.style.top = 'auto';
        sticky.style.bottom = 'auto';
      } else if (next === 'fixed') {
        sticky.style.position = 'fixed';
        sticky.style.top = '0px';
        sticky.style.bottom = 'auto';
      } else {
        sticky.style.position = 'absolute';
        sticky.style.top = 'auto';
        sticky.style.bottom = '0px';
      }
    }

    function apply(progress) {
      var shift = progress * metrics.travel;
      var width = metrics.width;
      track.style.transform = 'translate3d(' + -shift.toFixed(2) + 'px,0,0)';
      cards.forEach(function (card, index) {
        var ratio = (width * 0.75 + index * width * 0.5 - shift) / width;
        if (inners[index]) inners[index].style.transform = 'translate3d(0,' + cardY(ratio).toFixed(2) + 'px,0)';
        if (ratio < 1.05) playMeta(card);
        if (ratio < 1) growLine(card, index);
      });
    }

    function frame(now) {
      if (!lastTime) lastTime = now;
      var dt = Math.min(0.032, (now - lastTime) / 1000);
      lastTime = now;
      var follow = 1 - Math.exp(-dt / 0.18);
      current += (target - current) * follow;
      if (Math.abs(target - current) < 0.0008) current = target;
      apply(current);
      if (current === target) {
        running = false;
        lastTime = 0;
        return;
      }
      window.requestAnimationFrame(frame);
    }

    function sync() {
      if (!desktopMotion()) {
        pin.style.height = 'auto';
        mode = '';
        sticky.style.position = 'relative';
        sticky.style.top = 'auto';
        sticky.style.left = 'auto';
        sticky.style.width = '100%';
        sticky.style.height = 'auto';
        track.style.transform = 'none';
        inners.forEach(function (inner, index) {
          if (inner) inner.style.transform = 'none';
          playMeta(cards[index]);
        });
        playTitle(title);
        return;
      }
      target = readTarget();
      place();
      revealTitle();
      if (!snapped) {
        current = target;
        snapped = true;
        apply(current);
        return;
      }
      if (!running) {
        running = true;
        lastTime = 0;
        window.requestAnimationFrame(frame);
      }
    }

    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', function () {
      mode = '';
      snapped = false;
      metrics = null;
      sync();
    });
  }

  function build(section, data) {
    if (!data.items.length || section.querySelector('.leaves-series-trionn')) return;

    var pin = document.createElement('div');
    pin.className = 'leaves-series-trionn-pin';
    var sticky = document.createElement('div');
    sticky.className = 'leaves-series-trionn-sticky';
    var track = document.createElement('div');
    track.className = 'leaves-series-trionn';
    track.innerHTML =
      '<div class="leaves-series-trionn__copy">' +
      '<div class="leaves-series-trionn__title-block">' +
      '<h2 class="leaves-series-trionn__title">' +
      splitTitle(data.title) +
      '</h2></div></div>' +
      data.items.map(renderCard).join('');

    sticky.appendChild(track);
    pin.appendChild(sticky);

    Array.prototype.forEach.call(data.headings, hideOriginal);
    hideOriginal(data.flex.querySelector('[data-leaves-type="ContentList2"]'));
    hideOriginal(data.more);
    data.flex.appendChild(pin);
    section.classList.add('leaves-series-trionn-host');

    var title = track.querySelector('.leaves-series-trionn__title');
    splitChars(title);
    bindMotion(pin, sticky, track, title);
  }

  function mount() {
    var section = findSection();
    if (!section) return;
    build(section, collect(section));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
